<template>
 
    

    <div class="main">
      <div class="header d-flex align-items-center p-3 bg-white shadow-sm">
      <!-- Logo on the left -->
      <img src="../assets/images/logo_full.png" width="286" height="83" alt="Logo" />

      <!-- Title in the middle -->
      <div class="text-center" style="margin-left:25%">
        <h4 class="mb-0 text-uppercase font-weight-bold" style="font-size: 20px;
    color: #2279B3;">
          ΠΑΡΑΚΟΛΟΥΘΗΣΗ ΚΑΙ ΕΛΕΓΧΟΣ ΔΙΑΚΙΝΗΣΗΣ
        </h4>
        <h4 class="mb-0 text-uppercase font-weight-bold" style="font-size: 20px;
    color: #2279B3;">          ΙΣΤΙΚΩΝ ΜΟΣΧΕΥΜΑΤΩΝ        </h4>
      </div>
    </div>
  <div id="mytask-layout" class="theme-indigo">
        <!-- Body: Body -->
            <slot />
      </div>
    </div>
</template>

<script>
export default {
  name: 'LoginLayout'
};
</script>

<style scoped>
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow: hidden; /* Disable scrolling */
}
</style>
